import { showModal } from 'modal.react.js';
import { useHistory, useLocation } from 'react-router';

import area from 'components/shared/GlobalModalArea/area';
import AlertModal from 'components/shared/GlobalModalArea/Modal/AlertModal';
import { history as storeHistory } from 'configureStore';

export const useTitleChangeModal = () => {
  const history = useHistory();
  const location = useLocation();

  const handleClick = (isReadonly: boolean) => {
    if (isReadonly) return;
    const newRoute = location.pathname.replace('landing', 'general-info');

    showModal(area, (res) => {
      const unregister = storeHistory.listen(() => res());
      const handleClose = () => {
        res();
        unregister();
      };

      return (
        <AlertModal
          headerText="Heads Up!"
          confirmButtonText="Yes, Go"
          closeButtonText="Cancel"
          res={res}
          onAccept={() => {
            history.push(newRoute);
            handleClose();
          }}
          bodyText={
            <>
              Edits to this page can only be done in the General Info Tab. <br /> Do you want to go there now?
            </>
          }
        />
      );
    });
  };

  return handleClick;
};
